import { render, staticRenderFns } from "./Posmws.vue?vue&type=template&id=5430333f&"
import script from "./Posmws.vue?vue&type=script&lang=js&"
export * from "./Posmws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports